var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索文字...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchTask
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('RadioGroup', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "on-change": function ($event) {
        return _vm.loadTask(0);
      }
    },
    model: {
      value: _vm.filterQuery.category,
      callback: function ($$v) {
        _vm.$set(_vm.filterQuery, "category", $$v);
      },
      expression: "filterQuery.category"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "all"
    }
  }, [_vm._v("全部")]), _c('Radio', {
    attrs: {
      "label": "sales"
    }
  }, [_vm._v("销售")]), _c('Radio', {
    attrs: {
      "label": "research"
    }
  }, [_vm._v("研发")]), _c('Radio', {
    attrs: {
      "label": "techservice"
    }
  }, [_vm._v("技服")]), _c('Radio', {
    attrs: {
      "label": "factory"
    }
  }, [_vm._v("厂务")]), _c('Radio', {
    attrs: {
      "label": "shipping"
    }
  }, [_vm._v("运输")]), _c('Radio', {
    attrs: {
      "label": "fin"
    }
  }, [_vm._v("财务")]), _c('Radio', {
    attrs: {
      "label": "office"
    }
  }, [_vm._v("总经办")])], 1), _c('RadioGroup', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "on-change": function ($event) {
        return _vm.loadTask(0);
      }
    },
    model: {
      value: _vm.filterQuery.progress,
      callback: function ($$v) {
        _vm.$set(_vm.filterQuery, "progress", $$v);
      },
      expression: "filterQuery.progress"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "all"
    }
  }, [_vm._v("全部")]), _c('Radio', {
    attrs: {
      "label": "created"
    }
  }, [_vm._v("未完成")]), _c('Radio', {
    attrs: {
      "label": "finished"
    }
  }, [_vm._v("已完成")]), _c('Radio', {
    attrs: {
      "label": "canceled"
    }
  }, [_vm._v("取消")])], 1), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.TaskeCategoryModal.openModal();
      }
    }
  }, [_vm._v("权限")])], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 50,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadTask
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showNewTask = true;
      }
    }
  }, [_vm._v("新增任务")])], 1)]), _c('div', {
    staticClass: "task-wrapper"
  }, [_c('div', {
    staticClass: "task-area"
  }, [_vm.showNewTask ? _c('div', {
    staticClass: "new-task-area"
  }, [_c('div', {
    staticClass: "new-task-input-area"
  }, [_c('h2', {
    staticStyle: {
      "width": "170px"
    }
  }, [_vm._v("新任务：")]), _c('Select', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: _vm.newTask.mainResponsible,
      callback: function ($$v) {
        _vm.$set(_vm.newTask, "mainResponsible", $$v);
      },
      expression: "newTask.mainResponsible"
    }
  }, _vm._l(_vm.simpleUserList, function (user) {
    return _c('Option', {
      key: user._id,
      attrs: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.name))]);
  }), 1), _c('Input', {
    ref: "input-title",
    attrs: {
      "placeholder": "任务"
    },
    on: {
      "on-enter": _vm.createNewTask
    },
    model: {
      value: _vm.newTask.title,
      callback: function ($$v) {
        _vm.$set(_vm.newTask, "title", $$v);
      },
      expression: "newTask.title"
    }
  }), _c('Input', {
    ref: "input-deadLine",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "placeholder": "截止时间"
    },
    on: {
      "on-enter": _vm.createNewTask
    },
    model: {
      value: _vm.newTask.deadLine,
      callback: function ($$v) {
        _vm.$set(_vm.newTask, "deadLine", $$v);
      },
      expression: "newTask.deadLine"
    }
  })], 1), _c('div', {
    staticClass: "new-task-btn-area"
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.createNewTask
    }
  }, [_vm._v("保存")]), _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function ($event) {
        _vm.showNewTask = false;
      }
    }
  }, [_vm._v("取消")])], 1)]) : _vm._e(), _vm._m(0), _vm._l(_vm.taskList, function (task) {
    return _c('div', [_c('TaskBox', {
      attrs: {
        "task": task
      }
    })], 1);
  })], 2)]), _c('EditTaskDrawer', {
    ref: "EditTaskDrawer"
  }), _c('TaskeCategoryModal', {
    ref: "TaskeCategoryModal"
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "task-title"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(" 创建日期 ")]), _c('div', {
    staticClass: "col"
  }, [_vm._v(" 负责人 ")]), _c('div', {
    staticClass: "col",
    staticStyle: {
      "width": "590px"
    }
  }, [_vm._v(" 内容 ")]), _c('div', {
    staticClass: "col"
  }, [_vm._v(" 截止日期 ")]), _c('div', {
    staticClass: "col"
  }, [_vm._v(" 进度 ")]), _c('div', {
    staticClass: "col"
  }, [_vm._v(" 类型 ")]), _c('div', {
    staticClass: "col"
  }, [_vm._v(" 创建人 ")])]);

}]

export { render, staticRenderFns }